// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"bccfd427","653":"674df73d","752":"f662b253","756":"61e9a8ee","953":"9fbb3ae7"}[chunkId] + ".chunk.css";
};